@use "@fukuri-admins/ui/layout" as *;

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 240px;
  border: 1px solid border('Tertiary');
  border-radius: borderRadius('lg');
  gap: spacing('24');
  padding: spacing('32');
}

.message {
  @include typography('Jp/16_W3');
  color: text('Low');
  text-align: center;
}
